const WHITE = "#FFFFFF";
const PRIMARY_SOLID = "#e8a442";
const PRIMARY_GRADIENT = "linear-gradient(0deg, #D39118, #FFCB43)";
const GOLDEN = "linear-gradient(0deg, #C7831F, #FFB930)";
const GOLDEN_VERTICAL = "linear-gradient(0deg, #C7831F, #FFB930)";
const BUTTON_DISABLED = "#c7831f";
const BLACK_GRADIENT = "linear-gradient(0deg, #342E21, #000000)";
const TEXT_COLOR = "#342309";
const DARK_1 = "#6c6559";
const DARK_2 = "#918268";
const DARK_3 = "#c4bbac";
const DARK_4 = "#f4f1eb";
const BACKGROUND = "#f4ede2";
const LIST_COLOR = "#faf6f1";
const DIVIDER = "#ddd7cd";
const ERROR = "#e81530";
const ERROR_LABEL = "#ffd0d0";
const GREEN_LIGHT_LABEL = "#d3feb2";
const GREEN = "#23ab41";
const YELLOW_LIGHT_LABEL = "#fff1a7";

const lightTheme = {
  primarySolid: PRIMARY_SOLID,
  primaryGradient: PRIMARY_GRADIENT,
  golden: GOLDEN,
  goldenVertical: GOLDEN_VERTICAL,
  buttonDisabled: BUTTON_DISABLED,
  blackGradient: BLACK_GRADIENT,
  textColor: TEXT_COLOR,
  dark1: DARK_1,
  dark2: DARK_2,
  dark3: DARK_3,
  dark4: DARK_4,
  white: WHITE,
  background: BACKGROUND,
  listColor: LIST_COLOR,
  divider: DIVIDER,
  error: ERROR,
  errorLabel: ERROR_LABEL,
  greenLightLabel: GREEN_LIGHT_LABEL,
  green: GREEN,
  yellowLightLabel: YELLOW_LIGHT_LABEL,
  appbarColor: PRIMARY_GRADIENT,
  navbarColor: BLACK_GRADIENT,
};

export default lightTheme;
